import axiosInstance from '@/services/axiosInstance'
import mock from '@/services/mock/index'

async function subsanarVerifactu (params = null, payload = null) {
  if (process.env.VUE_APP_ENVIRONMENT === 'test') {
    return new Promise((resolve, reject) => {
      resolve(mock.getUser)
    })
  } else {
    const req = {
      url: '/api/verifactu/subsanarVerifactu',
      method: 'POST',
      headers: {
        'Content-type': 'application/json',
        'access-control-allow-origin': '*'
      },
      data: payload,
      params
    }
    const res = await axiosInstance(req)
    return res.data
  }
}

export { subsanarVerifactu }
